<template>
  <div class="app-friend-notification-wrapper">
    <div class="content">
      <slot name="txtBefore"></slot>
      <FriendNotification
        :process-name="'friendNotification'"
        :msisdn.sync="friendMsisdn"
        ref="friendNotificationComponent"
        @updatedCaptcha="updateCaptchaCode"
      >
        <template v-for="slot in possibleChildSlotsFor('Friend')" v-slot:[`${slot.child}`]>
          <slot :name="`${slot.parent}`"></slot>
        </template>
      </FriendNotification>
      <slot name="txtAfter"></slot>
    </div>
    <Stepper
      @next="next()"
      :show-prev="false"
      :disabled-next="disabledNext"
    >
      <template v-for="slot in possibleChildSlotsFor('Stepper')" v-slot:[`${slot.child}`]>
        <slot :name="`${slot.parent}`"></slot>
      </template>
    </Stepper>
  </div>
</template>
<script>

import FriendNotification from './FriendNotification'
import Stepper from '@/components/generic/Stepper'
import slotProxy from '@/mixins/slotProxy'
import transaction from '@/mixins/transaction'
import { mapActions } from 'vuex'
export default {
  name: 'FriendNotificationWrapper',
  data () {
    return {
      friendMsisdn: '',
      captchaInput: ''
    }
  },
  components: { FriendNotification, Stepper },
  computed: {
    disabledNext () {
      return this.friendMsisdn.trim() === '' || this.captchaInput.trim() === ''
    }
  },
  methods: {
    ...mapActions('friendNotification', [
      'referFriendSelfCare'
    ]),
    next () {
      this.referFriendSelfCare({ newCustomerMsisdn: this.friendMsisdn }).then((response) => {
        if (response?.success) {
          this.friendMsisdn = ''
        }
        this.$refs.friendNotificationComponent.reloadCaptchaComponent()
      })
    },
    updateCaptchaCode (captchaData) {
      this.captchaInput = captchaData.code
    }
  },
  mixins: [
    transaction('friendNotification'),
    slotProxy()
  ]
}
</script>
